import { useEffect } from "react";
import { IS_DEV_ENV } from "@/constants/envConstants";

export function useAppVersionCheck() {
    useEffect(() => {
        if (IS_DEV_ENV) return;

        (async () => {
            try {
                const manifestResponse = await fetch("/manifest.json", {
                    cache: "no-store",
                    headers: { "Cache-Control": "no-cache" },
                });

                if (!manifestResponse.ok) {
                    console.warn("Manifest file not accessible. Skipping update check.");
                    return;
                }
                const manifest = await manifestResponse.json();
                let latestJsFile = manifest["index.html"]?.file;
                if (!latestJsFile) {
                    console.warn("Unable to find main JavaScript file in manifest.");
                    return;
                }
                latestJsFile = latestJsFile.replace("assets/", "");

                const scripts = document.getElementsByTagName("script");
                const currentScript = Array.from(scripts).find(
                    (script) => script.src.includes("assets/index-") && script.src.endsWith(".js"),
                );

                if (!currentScript) {
                    console.warn("Unable to find current script in the DOM.");
                    return;
                }

                const currentJsFile = currentScript.src.split("/").pop();

                if (currentJsFile !== latestJsFile) {
                    const url = window.location.href.split("?")[0];
                    window.location.href = url + "?refresh=" + Date.now();
                }
            } catch (error) {
                console.error("Error checking for updates:", error);
            }
        })();
    }, []);
}